<template>
  <div
    class="w-full p-3 mt-5 rounded-lg bg-[#F7F6FB] md:flex hidden"
    v-if="propertyTypes"
  >
    <div class="grid grid-cols-4 gap-4">
      <div
        class="flex flex-col items-start w-56 space-y-2 text-sm text-gray-600"
        v-for="propertyType in propertyTypes.data"
        :key="propertyType.id"
      >
        <button @click="getPropertiesByPropertyTypes(propertyType.id)">
          {{ propertyType.name }} ({{ propertyType.properties_count }})
        </button>
      </div>
    </div>
    <div
      class="flex items-end pt-5 ml-auto text-sm text-gray-600"
      v-if="propertyTypes.length > 7"
    >
      <a href="" class="flex items-center text-sm font-semibold text-primary">
        <span>Show more</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-5 h-5"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="m19.5 8.25-7.5 7.5-7.5-7.5"
          />
        </svg>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    propertyTypes: Object,
  },
  methods: {
    getPropertiesByPropertyTypes(propertyTypeId) {
      const queryParams = {
        property_type_id: propertyTypeId,
      };
      this.$emit("get-properties-by-property-type", queryParams);
    },
  },
};
</script>
